import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { DocumentSearchDetailsModel, DocumentSearchParameters } from "@us/Services/DocumentSearch/DocumentSearchService";
import { DocumentSearchDataState } from "@us/Store/Data/DocumentSearchDataState";
import { Draft } from "immer";

const initialState: DocumentSearchDataState = {
    isLoading: false,
    documentSearchdata: null,
    pagination: null,
    initialDocumentTypes: "",
};

const reducer = {
    "Custom/DocumentSearchData/BeginLoadDocumentSearchData": (
        draft: Draft<DocumentSearchDataState>, 
        action: { result: DocumentSearchParameters },
    ) => {
        draft.isLoading = true;
        draft.initialDocumentTypes = action.result.initialDocumentTypes;
    },

    "Custom/DocumentSearchData/CompletedLoadDocumentSearchData": (
        draft: Draft<DocumentSearchDataState>,
        action: { result: DocumentSearchDetailsModel },
    ) => {
        draft.documentSearchdata = action.result;
        draft.pagination = action.result.pagination;
        draft.isLoading = false;
    },

};

export default createTypedReducerWithImmer(initialState, reducer);